var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgCo2 = function SvgCo2(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 14 14"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.5 5.5a2.49 2.49 0 0 0-1.79.76L7.68 5a3.5 3.5 0 1 0-4.5 1.79L2.61 9H2.5a2.51 2.51 0 1 0 1.08.25L4.15 7a2.09 2.09 0 0 0 .35 0 3.5 3.5 0 0 0 2.63-1.21l2 1.31A2.66 2.66 0 0 0 9 8a2.5 2.5 0 1 0 2.5-2.5Z"
  })));
};

export default SvgCo2;